export default {
  domain: 'N',
  title: 'Neurotizismus',
  shortDescription: 'Neurotizismus beschreibt die Tendenz zu negativen Gefühlen.',
  description: `Freud benutzte ursprünglich den Begriff Neurose um den 
Zustand der mentalen Verzweiflung, emotionalen Leidens und der 
Unfähigkeit die normalen Ansprüche des Lebens effizient zu bewältigen zu 
beschreiben. Er behauptete, dass jeder ein paar Zeichen von Neurose zeigt, 
aber dass sich diese in dem Ausmaß des Leidens und der spezifischen 
Symptome der Verzweiflung unterscheiden. Heutzutage bezieht sich 
Neurotizismus auf die Tendenz negative Gefühle zu durchleben. 
<br /><br />Die Menschen, die eine hohe Punktzahl in Neurotizismus haben, 
erleben primär ein spezifisches negatives Gefühl wie Angst, Wut, oder 
Depression, sind aber Anfällig dafür mehrere dieser Emotionen zu fühlen.
<br /><br />Diese Leute sind emotional reaktionsfreudig. Sie reagieren 
emotionaler auf Ereignisse als andere Menschen und ihre Reaktionen sind 
meist intensiver als bei anderen Menschen. Sie interpretieren gewöhnliche 
Situationen eher als bedrohlich, und kleine Frustrationen als 
hoffnungslose Fälle.
<br /><br />Ihre negativen emotionalen Reaktionen neigen dazu länger als 
gewöhnlich zu sein, was eine öftere schlechte Laune zur Folge hat. Diese 
Probleme bei der emotionalen Regulation reduziert sich bei einem Neurotiker 
auf die Fähigkeit klar zu denken, Entscheidungen zu treffen und Stress 
effektiv zu bewältigen.`,
  results: [
    {
      score: 'low',
      text: `Deine Punktzahl in Neurotizismus ist niedrig, was auf eine 
außergewöhnliche Ruhe, Gelassenheit und Unerschütterlichkeit hinweist. 
Du reagierst nicht mit starken Emotionen, auch wenn die meisten Leute 
die Situation als stressvoll beschreiben würden.`
    },
    {
      score: 'neutral',
      text: `Deine Punktzahl in Neurotizismus ist mittelmäßig, was auf 
eine Reaktionsweise hindeutet, die typisch für die Allgemeinbevölkerung 
ist. Anstrengende und frustrierende Situationen verärgern dich, aber du 
bist generell in der Lage Herr über deine Gefühle zu sein und die 
Situationen zu bewältigen.`
    },
    {
      score: 'high',
      text: `Deine Punktzahl in Neurotizismus ist hoch, was darauf 
hindeutet, dass du schneller verärgert bist, selbst bei dem was die 
meisten Menschen als normale Anforderungen des Lebens erachten. Leute 
sehen dich als sensibel und emotional.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'Angst',
      text: `Die "Kampf-oder-Flucht"-Reaktion wird bei ängstlichen 
Individuen zu einfach und zu oft ausgelöst. Deshalb fühlen Menschen mit 
hoher Angst oft, dass jederzeit etwas gefährliches passieren wird. Sie 
können vor einer spezifischen Situation Angst haben oder sind generell 
ängstlich. Sie fühlen sich angespannt, zitterig und nervös. Personen mit 
wenig Angst sind in der Regel ruhig und furchtlos.`
    },
    {
      facet: 2,
      title: 'Wut',
      text: `Personen mit einer hohen Punktzahl in Wut sind oft erzürnt 
wenn etwas nicht auf ihre Weise passiert. Ihnen ist es wichtig fair 
behandelt zu werden und sie reagieren gereizt wenn sie das Gefühl haben, 
dass sie getäuscht werden. Diese Skala misst die Tendenz zur Wut; ob die 
Person Verärgerungen und Feindseligkeit zeigt hängt von der 
Verträglichkeit des Individuums ab. Personen mit niedriger Punktzahl in 
Wut werden weder schnell noch leicht böse.`
    },
    {
      facet: 3,
      title: 'Depression',
      text: `Diese Skala misst die Neigung dazu Traurigkeit, 
Schwermütigkeit, und Entmutigung zu fühlen. Personen mit hoher Punktzahl 
in Depression fehlt Energie und haben Schwierigkeiten Aktivitäten zu 
beginnen. Personen mit niedriger Punktzahl neigen dazu, diese depressiven 
Gefühle nicht zu haben.`
    },
    {
      facet: 4,
      title: 'Selbstbewusstsein',
      text: `Selbstbewussten Individuen ist es wichtig, was andere über 
sie denken. Ihre Sorge über Ablehnung und Spot lassen die Person 
schüchtern und ungemütlich in der Gesellschaft von anderen Leuten. Sie 
sind leicht und oft beschämt. Ihre Ängste, dass andere sie kritisieren 
oder über sie herziehen, sind oft übertrieben und unrealistisch, aber 
ihre Ungeschicklichkeit und Unwohlsein machen diese Ängste zu einer 
selbsterfüllenden Prophezeiung. Menschen mit niedriger Punktzahl 
hingegen leiden nicht unter diesem irrtümlichen Eindruck, dass jeder 
sie überwacht und verurteilt. Sie fühlen sich in sozialen Situationen 
nicht nervös.`
    },
    {
      facet: 5,
      title: 'Übermaß',
      text: `Übermäßige Individuen durchleben oft starke Gelüste und 
Triebe, denen sie nur schwer widerstehen können. Sie neigen zu 
kurzzeitigen Befriedigungen und Belohnungen statt langfristigen Zielen. 
Menschen mit niedriger Punktzahl erleben keine starken, 
unwiderstehlichen Gelüsten und können diesen somit nicht verfallen.`
    },
    {
      facet: 6,
      title: 'Empfindlichkeit',
      text: `Leute mit hoher Punktzahl in Empfindlichkeit erleben Panik, 
Verwirrung und Hilflosigkeit unter Druck oder Stress.
Menschen mit niedriger Punktzahl fühlen sich unter Stress 
selbstsicherer, zuversichtlicher und denken klarer.`
    }
  ]
};
